import React from "react";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import AprmTable from "./AprmTable";
import { toast } from "react-toastify";
import { Rm_Ap_Mapping } from "../../Configuration/API_URL";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { Constants } from "../../CommonMethhods/Constants";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { useDebounce } from "../../Components/useDebounce";

function AprmMapping() {
  const [optionVal, setOptionVal] = useState([]);
  const [rmVal, setRmVal] = useState([]);
  const [rmReport, setRmReport] = useState([]);
  const [isSave, setIsSave] = useState(false);
  const [page, setPage] = useState(1);
  const [rmPage, setRmPage] = useState(1);
  const [clientShow, setClientShow] = useState(false);
  const [branchVal, setBranchVal] = useState([]);
  const [branchCount, setBranchCount] = useState();
  const [branchShow, setBranchShow] = useState(false);
  const [scrollBranchLoader, setScrollBranchLoader] = useState(false);
  const [branchPage, setBranchPage] = useState(1);
  const [branchCode, setBranchCode] = useState("");
  const [errorBranchName, setErrorBranchName] = useState(false);
  const [scrollApLoader, setScrollApLoader] = useState(false);
  const [scrollRmLoader, setScrollRmLoader] = useState(false);
  const [rmShow, setRmShow] = useState(false);
  const [clientCode, setClientCode] = useState({ name: "", code: "" });
  const [errorApName, setErrorApName] = useState("");
  const [errorRmName, setErrorRmName] = useState("");
  const [clientID, setClientID] = useState("");
  const [apCount, setApCount] = useState();
  const [rmCount, setRmCount] = useState();
  const [nameRm, setNameRm] = useState({ name: "", code: "" });
  const [serverError, setServerError] = useState("");
  const [loaderMain, setLoaderMain] = useState(false);
  const [isApFieldBlock, setIsApFieldBlock] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [tableErr, setTableErr] = useState("")

  const debouncedValue = useDebounce(clientCode, 1000);

  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  const rmDebouncedVal = useDebounce(nameRm, 1000);

  useEffect(() => {
    handleRmName(rmDebouncedVal);
  }, [rmDebouncedVal]);

  const branchDebouncedValue = useDebounce(branchCode, 1000);

  useEffect(() => {
    handleBranchName(branchDebouncedValue);
  }, [branchDebouncedValue])

  const searchDebouncedVal = useDebounce(searchVal, 1000);

  // useDebounce(()=>{
  //   handleSearch(searchDebouncedVal)
  // }, [searchDebouncedVal])

  useEffect(() => {
    if (searchDebouncedVal === "") {
      RMAPMappingReport("grid", "");
    } else {
      RMAPMappingReport("grid", searchDebouncedVal);
    }
  }, [searchDebouncedVal]);

  useEffect(() => {
    if (rmPage > 1 || nameRm === "") {
      GetRMName();
    }
  }, [rmPage, nameRm]);

  useEffect(() => {
    if (page > 1 || clientCode === "") {
      GetAPCode();
    }
  }, [page, clientCode]);

  const processResponse = (data) => {
    const finalRes = [];
    if (data.length > 0) {
      data.map((data, index) => {
        let Object = {
          value: data.value,
          label: data.name,
        };
        finalRes.push(Object);
      });
    }
    return finalRes;
  };

  const GetAPCode = async () => {
    let payloadValue = {
      search: clientCode?.code || "",
      pageNo: page,
      pageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValue");

    try {
      const response = await axios.post(
        Rm_Ap_Mapping.Get_AP_Code_URL,

        `"${encPayload}"`,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const responseDecrypt = ApiResDecrypt(response?.data);

      const res = await responseDecrypt.data;
      setApCount(res.totalcount);
      if (res) {
        setOptionVal((prev) => {
          return [...prev, ...processResponse(res.clients)];
        });
        setErrorApName("");
      } else {
        setOptionVal([]);
        setErrorApName("No data found");
      }
    } catch (err) {
    } finally {
      setScrollApLoader(false);
    }
  };

  const GetRMName = async () => {
    let payloadValue = {
      search: nameRm.code || "",
      pageNo: rmPage,
      pageSize: "10",
    };
    let encPayload = AESEncryption(payloadValue);

    console.log(payloadValue, "rmPayload");

    try {
      const response = await axios.post(
        Rm_Ap_Mapping.Get_RM_Name_URL,
        `"${encPayload}"`,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const responseDecrypt = ApiResDecrypt(response?.data);
      if (responseDecrypt?.status === 0) {
        console.log(responseDecrypt?.data, "clhfjf");
        setErrorRmName(false);
        setRmCount(responseDecrypt?.data.totalcount);
        if (rmPage > 1) {
          setRmVal((prev) => {
            return [...prev, ...responseDecrypt?.data?.clients];
          });
        } else {
          setRmVal(responseDecrypt?.data?.clients);
        }
      } else {
        setRmVal([]);
        setErrorRmName(responseDecrypt?.message);
      }
    } catch (err) {
    } finally {
      setScrollRmLoader(false);
    }
  };

  const GetBranchName = async (searchValue) => {
    let payloadValue = {
      search: searchValue,
      pageNo: branchPage,
      pageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const response = await axios.post(
        Rm_Ap_Mapping.Get_Branch_Name_URL,
        `"${encPayload}"`,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const responseDecrypt = ApiResDecrypt(response?.data);
      if (responseDecrypt?.status === 0) {
        setErrorBranchName(false);
        setBranchCount(responseDecrypt?.data.totalCount);
        if (branchPage > 1) {
          setBranchVal((prev) => {
            return [...prev, ...responseDecrypt?.data?.branchList];
          });
        } else {
          setBranchVal(responseDecrypt?.data?.branchList);
        }
      } else {
        setBranchVal([]);
        setErrorBranchName(responseDecrypt?.message);
      }
    } catch (err) {
      setBranchVal([]);
      setErrorBranchName(err?.message);
    } finally {
      setScrollBranchLoader(false);
    }
  };
  console.log(clientCode, clientCode?.code, "clientCode");


  useEffect(() => {
    if (branchPage > 1 || branchCode === "") {
      GetBranchName(branchCode);
    }

  }, [branchPage, branchCode]);

  function childUpdate(data) {
    setIsApFieldBlock(true);
    setClientCode({ name: data.apName, code: data.apCode });
    setNameRm({ name: data.rmName, code: data.rmCode });
    setBranchCode(data.branch);
    setIsSave(true);
    setClientID(data.id);
  }

  function reset() {
    setNameRm({ name: "", code: "" });
    setClientCode({ name: "", code: "" });
    setBranchCode("");
    setIsSave(false);
    setIsApFieldBlock(false);
  }

  const SaveRmCodeApName = async () => {
    setLoaderMain(true);
    let payloadValue = {
      apCode: clientCode?.code,
      apName: clientCode?.name,
      rmCode: nameRm?.code,
      rmName: nameRm?.name,
      branch: branchCode,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const response = await axios.post(
        Rm_Ap_Mapping.Save_Rm_Code_Ap_Name_URL,

        `"${encPayload}"`,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const decryptResponse = ApiResDecrypt(response?.data);
      if (decryptResponse?.status === 0) {
        toast.success(decryptResponse.data.message);
        setNameRm({ name: "", code: "" });
        setClientCode({ name: "", code: "" });
        setBranchCode("");
        RMAPMappingReport("grid", "");
        setIsApFieldBlock(false);
      } else {
        toast.error(decryptResponse.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
    finally {
      setLoaderMain(false);
    }
  };

  const RMAPMappingReport = async (fileType, value = "") => {
    let payloadValue = { type: fileType, search: value };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "searchPayload");

    try {
      const response = await axios.post(
        Rm_Ap_Mapping.RM_AP_Mapping_Report_URL,
        `"${encPayload}"`,

        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const data = ApiResDecrypt(response?.data);
      console.log(data, "searchTable");

      if (data.status === 0) {
        setTableErr("");
        if (fileType === "grid") {
          setRmReport(data?.data);
        } else if (fileType === "excel") {
          window.open(data?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (fileType === "grid") {
          setTableErr(data?.message)
          setRmReport([])
        } else if (fileType === "excel") {
          toast.error(data?.message);
        }
      }
    } catch (err) {
      setServerError("Somthing went wrong please try again later");
    } finally {
      setLoaderMain(false);
    }
  };

  //edit button
  const EditApRmName = async () => {
    let payloadValue = {
      id: clientID,
      apCode: clientCode.code,
      rmCode: nameRm?.code,
      rmName: nameRm?.name,
      branch: branchCode,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const response = await axios.post(
        Rm_Ap_Mapping.Update_RM_URL,

        `"${encPayload}"`,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(response?.data);
      console.log(res, "datatat");
      if (res.status === 0) {
        toast.success(res.data.message);
        RMAPMappingReport("grid", "");
        setNameRm({ name: "", code: "" });
        setClientCode({ name: "", code: "" });
        setBranchCode("");
        setIsApFieldBlock(false);
        setIsSave(false);
      } else {
        toast.error(res.message);
      }
    } catch (err) { }
  };
  //edit button end

  const handleScrollApCode = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollApLoader) {
      if (!(apCount <= page * 10)) {
        setPage((prev) => prev + 1);
        setScrollApLoader(true);
      }
    }
  };

  const handleScrollRmName = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollApLoader) {
      if (!(rmCount <= rmPage * 10)) {
        setRmPage((prev) => prev + 1);
        setScrollRmLoader(true);
      }
    }
  };

  function handleClientName(data) {
    // e.target.value = e.target.value.toUpperCase();
    setOptionVal([]);
    setPage(1);
    // setClientCode({ name: "", code: e.target.value });
    if (data) {
      GetAPCode()
      setErrorApName(false);
    }
  }

  function handleRmName(data) {
    // e.target.value = e.target.value.toUpperCase();
    setRmVal([]);
    setRmPage(1);
    // setNameRm({ name: "", code: e.target.value });
    if (data) {
      GetRMName();
      setErrorRmName(false);
    }
  }

  const handleScrollBranchName = async (e) => {
    const a = e.target;
    if (
      a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight &&
      !scrollBranchLoader
    ) {
      if (!(branchCount <= branchPage * 10)) {
        setBranchPage((prev) => prev + 1);
        setScrollBranchLoader(true);
      }
    }
  };

  function handleBranchName(data) {
    // e.target.value = e.target.value.toUpperCase();
    setBranchVal([]);
    setBranchPage(1);
    // setBranchCode(e.target.value);
    if (data) {
      GetBranchName(data)
      setErrorBranchName(false);
    }
  }

  // function handleSearch (data){
  //   if(data){
  //     RMAPMappingReport("grid", data);
  //   }
  // }

  const handleSaveSubmit = (button) => {
    if (
      branchCode &&
      clientCode.name &&
      clientCode.code &&
      nameRm.name &&
      nameRm.code
    ) {
      if (button !== "update") {
        SaveRmCodeApName();
      } else {
        EditApRmName();
      }
    } else {
      toast.error("All field are mandatory");
    }
  };

  return (
    <div className="card-box">
      <div className="row input-mapping align-items-center">
        <div className="col-md-4 col-sm-6 col-12">
          <div className="form-group">
            <label className="form-label">AP Code: </label>

            <>
              <div className="rm-custom-dropdown">
                <input
                  type="text"
                  name="search-text"
                  className="input-st"
                  placeholder="Search by Name/Code..."
                  autoComplete="off"
                  value={clientCode.code}
                  onFocus={() => setClientShow(true)}
                  onChange={(e) => {
                    setClientCode({ name: "", code: e?.target?.value?.toUpperCase() });
                    // handleClientName(e);
                  }}
                  onInput={(e) => {
                    const start = e.target.selectionStart;
                    const end = e.target.selectionEnd;
                    let input = e.target.value;
                    input = input
                      .toUpperCase()
                      .replace(/[^A-Z0-9\s]/g, "")
                      .replace(/\s+/g, " ")
                      .trimStart()
                      .slice(0, 100);

                    e.target.value = input;
                    e.target.setSelectionRange(start, end);
                  }}
                  disabled={isApFieldBlock}
                />

                <button
                  className="rm-dropdown-btn"
                  onClick={() => setClientShow(!clientShow)}
                >
                  <span className="icon-right-arrow-triangle"></span>
                </button>
                {clientShow && (
                  <>
                    <ul
                      className="rm-mapping-ap border-0"
                      onScroll={handleScrollApCode}
                    >
                      {optionVal.map((item, i) => (
                        <li
                          key={i}
                          onClick={() => {
                            setClientShow(false);
                            setClientCode({
                              name: item.value,
                              code: item.label,
                            });
                          }}
                          className="rm-maping-item-wrapper"
                        >
                          <div> {item.value}</div>
                          <div> {item.label}</div>
                        </li>
                      ))}
                      {scrollApLoader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}

                      {errorApName && (
                        <div className="rm-maping-no-data">{errorApName}</div>
                      )}
                    </ul>
                  </>
                )}
              </div>
            </>
          </div>
        </div>
        <div className="col-md-4 col-sm-6 col-12">
          <div className="form-group">
            <label className="form-label">RM Name: </label>
            <>
              <div className="rm-custom-dropdown">
                <input
                  type="text"
                  name="search-text"
                  className="input-st"
                  placeholder="Search by Name/Code..."
                  autoComplete="off"
                  value={nameRm.code}
                  onFocus={() => setRmShow(true)}
                  onChange={(e) => {
                    setNameRm({ name: "", code: e?.target?.value?.toUpperCase() });
                    // handleRmName(e);
                  }}
                  onInput={(e) => {
                    const start = e.target.selectionStart;
                    const end = e.target.selectionEnd;
                    let input = e.target.value;
                    input = input
                      .toUpperCase()
                      .replace(/[^A-Z0-9\s]/g, "")
                      .replace(/\s+/g, " ")
                      .trimStart()
                      .slice(0, 100);

                    e.target.value = input;
                    e.target.setSelectionRange(start, end);
                  }}
                />
                <button
                  className="rm-dropdown-btn"
                  onClick={() => setRmShow(!rmShow)}
                >
                  <span className="icon-right-arrow-triangle"></span>{" "}
                </button>
                {rmShow && (
                  <>
                    <ul
                      className="rm-mapping-ap border-0"
                      onScroll={handleScrollRmName}
                    >
                      {rmVal.map((item, i) => (
                        <li
                          key={i}
                          onClick={() => {
                            setRmShow(false);
                            setNameRm({ name: item.name, code: item.value });
                          }}
                          className="rm-maping-item-wrapper"
                        >
                          <div> {item.name}</div>
                          <div> {item.value}</div>
                        </li>
                      ))}
                      {scrollRmLoader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                      {errorRmName && (
                        <div className="rm-maping-no-data">{errorRmName}</div>
                      )}
                    </ul>
                  </>
                )}
              </div>
            </>
          </div>
        </div>
        <div className="col-md-4 col-sm-6 col-12">
          <div className="form-group">
            <label className="form-label">Branch Code: </label>
            <>
              <div className="rm-custom-dropdown">
                <input
                  type="text"
                  name="search-text"
                  className="input-st"
                  placeholder="Search by Name/Code..."
                  value={branchCode}
                  autoComplete="off"
                  onFocus={() => setBranchShow(true)}
                  onChange={(e) => {
                    setBranchCode(e?.target?.value?.toUpperCase());
                    // handleBranchName(e);
                  }}

                  onInput={(e) => {
                    const start = e.target.selectionStart;
                    const end = e.target.selectionEnd;
                    let input = e.target.value;
                    input = input
                      .toUpperCase()
                      .replace(/[^A-Z0-9\s]/g, "")
                      .replace(/\s+/g, " ")
                      .trimStart()
                      .slice(0, 100);

                    e.target.value = input;
                    e.target.setSelectionRange(start, end);
                  }}
                />
                <button
                  className="rm-dropdown-btn"
                  onClick={() => setBranchShow(!branchShow)}
                >
                  <span className="icon-right-arrow-triangle"></span>
                </button>
                {branchShow && (
                  <>
                    <ul
                      className="rm-mapping-ap border-0"
                      onScroll={handleScrollBranchName}
                    >
                      {branchVal.map((item, i) => (
                        <li
                          key={i}
                          className="rm-maping-item-wrapper"
                          onClick={() => {
                            setBranchShow(false);
                            setBranchCode(item.branch);
                          }}
                        >
                          <div> {item.branch}</div>
                        </li>
                      ))}
                      {scrollBranchLoader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                      {errorBranchName && (
                        <div className="rm-maping-no-data">
                          {errorBranchName}
                        </div>
                      )}
                    </ul>
                  </>
                )}
              </div>
            </>
          </div>
        </div>
      </div>
      <div className="save-btn">
        {isSave ? (
          <button
            className="margin-save"
            onClick={() => handleSaveSubmit("update")}
          >
            Update
          </button>
        ) : (
          <button
            className="margin-save"
            onClick={() => handleSaveSubmit("save")}
          >
            Save
          </button>
        )}

        <button className="margin-reset" onClick={reset}>
          Reset
        </button>
      </div>
      <div className="d-flex justify-content-end align-items-center">
        <div className="col-md-2 col-sm-6 col-6">
          <div className="form-group">
            <label className="form-label">{Constants.Client_Search} </label>
            <div className="">
              <input
                type="text"
                name="search-text"
                id="SearchInput"
                className="input-st"
                placeholder="Search here..."
                autoComplete="off"
                value={searchVal}
                onChange={(e) =>
                  setSearchVal(e?.target?.value?.toUpperCase())
                  // RMAPMappingReport("grid", e.target.value)
                }
                onInput={(e) => {
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;
                  let input = e.target.value;
                  input = input
                    .toUpperCase()
                    .replace(/[^A-Z0-9\s]/g, "")
                    .replace(/\s+/g, " ")
                    .trimStart()
                    .slice(0, 100);

                  e.target.value = input;
                  e.target.setSelectionRange(start, end);
                }}
              />
            </div>
          </div>
        </div>
        <button
          className="generate-btn text-green mt-3"
          value="excel"
          onClick={(e) => RMAPMappingReport("excel", "")}
        >
          <>
            <span className="icon-excelsvg"></span>
            {"Excel"}
          </>
        </button>
      </div>
      <div className="for-grid-section pnl-wrapper">
        {loaderMain ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : rmReport && rmReport?.length > 0 ?
          (
            <AprmTable
              tableErr={tableErr}
              rmReport={rmReport}
              childUpdate={childUpdate}
              serverError={serverError}
            />
          ) : serverError ?
            (<h4 className="report-error-message">
              {noDataFound(serverError)}
            </h4>
            )
            : (
              tableErr && noDataFound(tableErr)
            )
        }
      </div>
    </div>
  );
}

export default AprmMapping;
